import { I18N } from "aurelia-i18n";
import { Guid } from "../../../../../../utilities/guid";
import { BindingEngine, computedFrom, observable } from "aurelia-binding";
import { MenuItem } from "../../../../../components/menu/menu-item";
import { MobileHelper } from "../../../../../../helpers/mobile-helper";
import { Container, autoinject, transient } from "aurelia-dependency-injection";
import { CustomGridPageBase } from "../../../../common/custom-grid-page.base";
import { RulesClientService } from "../../../../../../services/rules/rules-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipDialogServiceConstants } from "../../../../../../constants/basics/rightship-dialog.constants";
import { DataGridColumn, DataType, QueryFilter, SourceType } from "../../../../../../models/queries/queries.models";
import { RulesHeader } from "../../partials/rules-header";
import { useView } from "aurelia-framework";

@autoinject()
@transient()
@useView('views/pages/modules/rules/tabs/rules/rules.html')
export class RulesTab extends CustomGridPageBase {

    @observable()
    public filter: string;
    public appliedFilter: string;
    public initialFilters: QueryFilter[];
    private odataUrl = "odata/Rules";
    public selectedFilter: { title: string, clear: () => void, apply: () => void };
    public isMobileFilterOpen: boolean = false;
    public mobileSelectedfilters : any[] = []
    public isColumnFiltering: boolean = false;

    constructor(i18N: I18N, protected bindingEngine: BindingEngine,
        private dialogClient: DialogClientService,
        private rulesClientService: RulesClientService,
        protected rulesHeader: RulesHeader) {
        super(i18N, 'Lists', bindingEngine);
        
    }

    activate() {
        this.columns = this.getColumns();
        this.itemSource = this.getItemSource([])
    }

    filterKeyDown($event) {
        const e = $event.detail;

        if (e.key == "Enter") {
            this.appliedFilter = this.filter;
            this.setItemSource();
        }
    }

    filterChanged() {
        if ((this.filter && this.filter.length >= 5) || this.filter == "") {
            this.appliedFilter = this.filter;
            this.setItemSource();
        }
    }

    getColumns(): DataGridColumn[] {
        return  [
            {
                dataType: DataType.CustomTemplate,
                value: `<check-box checked.bind="getRowItem() && getRowItem().isSelected"
                        changed.delegate="getDataGrid().selectRowInMultipleSelection(getRowItem())">
                    </check-box>`,
                name: "select",
                title: MobileHelper.isMobileDevice() ? "" : `<check-box class="check-box-select-all" checked.two-way="toggleAll"></check-box>`,
                parameter: {
                    item: null
                },
                instancePerRow: true,
                sortOrder: 1,
                columnOrder: -2,
                width: "38px",
                isHidden: false,
                isSortable: false,
                getCellClass: () => {
                    return "selector-checkbox";
                }
            },
            {
                dataType:  DataType.Double,
                name:  "sequenceNumber",
                title:  "Order Number",
                sortOrder:  0,
                columnOrder:  -2,
                isHidden:  false,
                isSortable:  true,
                width:  "100px"
            },
            {
                dataType:  DataType.Default,
                name:  "ruleCode",
                title:  "Rule Code",
                sortOrder:  0,
                columnOrder:  -2,
                isHidden:  false,
                isSortable:  true,
                width:  "100px"
            },
            {
                dataType:  DataType.CustomTemplate,
                value: (item, row, column, dataGridVM) => {
                    if (item && dataGridVM) {
                        const dialogClient = Container.instance.get(DialogClientService);
                        dialogClient.show(RightShipDialogServiceConstants.URLs.AddRuleDialog, {
                            dataGrid: dataGridVM,
                            ruleId: item.id
                        }, true, false, false, 'right');
                    }
                    return '<a click.trigger="getDataGrid().handleClickOnButton($event,getRowItem(),getRowItem().columnKeys[`ruleName`].column)" class="link au-target" href="#" >${item.ruleName}</a>';
                },
                name:  "ruleName",
                title:  "Name",
                instancePerRow:  true,
                sortOrder:  1,
                columnOrder:  -1,
                isHidden:  false,
                isSortable:  true,
                width:  "150px",
                parameter: {
                    item: null
                }
                
            },
            {
                dataType:  DataType.Default,
                name:  "ruleCategory",
                title:  "Category",
                sortOrder:  2,
                columnOrder:  2,
                isHidden:  false,
                isSortable:  true,
                width:  "150px"
            },
            {
                dataType:  DataType.Default,
                name:  "ruleSeverity",
                title:  "Severity",
                sortOrder:  3,
                columnOrder:  3,
                isHidden:  false,
                isSortable:  true,
                width:  "150px"
            },
            {
                dataType:  DataType.Default,
                name:  "createdBy",
                title:  "Created By",
                sortOrder:  4,
                columnOrder:  4,
                isHidden:  false,
                isSortable:  true,
                width:  "150px"
            },
            {
                dataType:  DataType.Default,
                name:  "lastModifiedBy",
                title:  "Last Modified by",
                sortOrder:  5,
                columnOrder:  5,
                isHidden:  false,
                isSortable:  true,
                width:  "150px"
            },
            {
                dataType:  DataType.Boolean,
                name:  "isActive",
                title:  "Is Active",
                sortOrder:  5,
                columnOrder:  5,
                isHidden:  false,
                isSortable:  true,
                width:  "100px"
            },
            {
                columnOrder: 99,
                sortOrder: 99,
                dataType: DataType.CustomTemplate,
                instancePerRow: true,
                name: "menu",
                value: `<div class="actions row justify-content-end align-items-middle">
                                <list-menu hide-menu-border="true" menu-items.bind="menuItems(item, getDataGrid())" if.bind="menuItems(item, getDataGrid()).length > 0">
                                    <template replace-part="menu-item">
                                        <div class="row nowrap align-items-middle">
                                            <span class="text">\${menuItem.item.text}</span>
                                        </div>  
                                    </template>
                                </list-menu>
                            </div>`,
                parameter: {
                    item: null,
                    menuItems: (item, dataGridVM) => {
                        const menuItems: MenuItem[] = [];
                        menuItems.push({
                            isVisible: true, click: () => {
                                
                                //Open add rule dailog
                                this.dialogClient.show(RightShipDialogServiceConstants.URLs.AddRuleDialog,
                                    { dataGrid: dataGridVM, ruleId: item.id, isClone: true }, true, false, false, 'right')
                            },
                            item: { text: "Clone" }, classList: ''
                        });
                        menuItems.push({
                            isVisible: true, click: () => this.dialogClient.show(RightShipDialogServiceConstants.URLs.RuleAuditDialog,
                                { ruleConfigId: item.id }, true, false, false, 'right'), item: { text: "Audit" }, classList: ''
                        });
                        menuItems.push({
                            isVisible: true, click: () =>
                                this.rulesClientService.downloadRuleBusinessUnitsExcel(item.ruleConfigId, item.ruleName),
                            item: { text: "Download" }, classList: ''
                        });
                        return menuItems;
                    }
                }
            }
        ];
    }

    private getItemSource(filters) {
        this.initialFilters = filters;
        return {
            sourceType: SourceType.ODataUrl,
            source: this.odataUrl,
            columns: this.columns,
            initialFilters: this.initialFilters,
            initialSorting: this.initialSorting
        };
    }

    closeAllFilters() {
        this.showONFilter = false;
        this.showCategoryFilter = false;
        this.showIsCustomerFilter = false;
        this.showSeverityFilter = false;
        this.showActiveFilter = false;
    }

    private setItemSource() { 
        const currentFilters: QueryFilter[] = []; 

        if(this.filter){
            const guid = Guid.generateGuid();
            currentFilters.push(QueryFilter.getQuery("ruleCode", this.filter, "contains({0}, '{1}')", DataType.Default, false, false, guid, true, true))
            currentFilters.push(QueryFilter.getQuery("ruleName", this.filter, "contains({0}, '{1}')", DataType.Default, false, false, guid, true, true))
        }

        // Order Number Filter
        if(this.oNFilterActive) {
            const guid = Guid.generateGuid();
            currentFilters.push(QueryFilter.getQuery("sequenceNumber", this.firstONFilter, "ge", DataType.Number,true,false,guid,true,false))
            currentFilters.push(QueryFilter.getQuery("sequenceNumber", this.secondONFilter, "le", DataType.Number,true,false,guid,true,false))
        }

        // category filter
        if(this.categoryFilterActive) {
            const categoryFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "ruleCategoryId",
                    isDynamicProperty: false,
                    type: DataType.Lookup,
                    lookupMappedToProperty: "RS_RuleCategories",
                    isNullable: true,
                },
                filterValue: this.selectedCategories || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };
            currentFilters.push(categoryFilter) 
        }

        // Is Customer filter
        if(this.isCustomerFilterActive) {
            if(this.selectedIsCustomer.length == 1) {
                const isCustomer = this.selectedIsCustomer[0] == this.isCustomerOptions[0].id
                currentFilters.push(QueryFilter.getQuery('isCustomer ', isCustomer, "eq",DataType.Boolean,true, false))
            }
        }

        // Severity Filter
        if(this.severityFilterActive) {
            const categoryFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "ruleSeverityId",
                    isDynamicProperty: false,
                    type: DataType.Lookup,
                    lookupMappedToProperty: "RS_RuleSeverities",
                    isNullable: true,
                },
                filterValue: this.selectedSeverities || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };
            currentFilters.push(categoryFilter) 
        }

        // Active filter
        if(this.activeFilterActive) {
            if(this.selectedActive.length == 1) {
                const isActive = this.selectedActive[0] == this.activeOptions[0].id
                currentFilters.push(QueryFilter.getQuery('isActive', isActive, "eq",DataType.Boolean, true, true))
            }
        }    

        this.itemSource = this.getItemSource(currentFilters);
    }

    public get isSubFilterOpen(): boolean {
        return this.showONFilter || this.showCategoryFilter || this.showIsCustomerFilter || this.showSeverityFilter ||this.showActiveFilter;
    }

    //#region Order Number filter
    public oNDefaults: {low: number, high:number, min: number, max: number} = {low: 0,high:100, min:0, max:1000}
    public firstONFilter:number = this.oNDefaults.low;
    public secondONFilter:number = this.oNDefaults.high;
    public showONFilter: boolean;
    public oNIsApplied: boolean;

    toggleONFilter() {
        if(!this.showONFilter) {
            this.closeAllFilters();
        }
        this.showONFilter = !this.showONFilter;
    }
    public oNSetSelectedFilter() {
        this.selectedFilter = {
            title: "OrderNumber",
            clear: () => {
                this.clearONFilter();
            },
            apply: () => {
                this.showONFilter = false;
            }
        }
    }
    public clearONFilter(reload = true) {
        this.firstONFilter = this.oNDefaults.low;
        this.secondONFilter = this.oNDefaults.high;
        this.oNIsApplied = false;

        if(reload)
            this.setItemSource();
    }

    public applyONFilter() {
        if(this.secondONFilter != this.oNDefaults.high && this.secondONFilter > this.oNDefaults.max)
        {
            this.secondONFilter = this.oNDefaults.max;
        }
        
        this.setItemSource();
        this.showONFilter = false;
    }
    @computedFrom("firstONFilter", "secondONFilter") 
    public get oNFilterActive() : boolean { 
        return this.firstONFilter > this.oNDefaults.low || this.secondONFilter != this.oNDefaults.high;
    }
    //#endregion
    
    //#region Category filter
    public selectedCategories : any[] = [];
    public showCategoryFilter: boolean;
    public categoryIsApplied: boolean;
    toggleCategoryFilter() {
        if(!this.showCategoryFilter) {
            this.closeAllFilters();
        }
        this.showCategoryFilter = !this.showCategoryFilter;
    }
    public categorySetSelectedFilter() {
        this.selectedFilter = {
            title: "Category",
            clear: () => {
                this.clearCategoryFilter();
            },
            apply: () => {
                this.showCategoryFilter = false;
            }
        }
    }
    public clearCategoryFilter(reload = true) {
        this.selectedCategories = []
        this.categoryIsApplied = false;
        if(reload)
            this.setItemSource();
    }

    public applyCategoryFilter(items ) { 
        this.selectedCategories = items.filter(x => x.isSelected).map(x => x.id)
        this.setItemSource();
        this.showCategoryFilter = false;
    }
    @computedFrom("selectedCategories") 
    public get categoryFilterActive() : boolean {
        return this.selectedCategories && this.selectedCategories.length > 0;
    }
    //#endregion

    // #region IsCustomer filter
    public selectedIsCustomer : any[] = []
    public isCustomerOptions : any[] = [{id: 0, name: "Customer"}, {id: 1, name: "Not Customer"}]
    public showIsCustomerFilter: boolean;
    public isCustomerIsApplied: boolean;
    toggleIsCustomerFilter() {
        if(!this.showIsCustomerFilter) {
            this.closeAllFilters();
        }
        this.showIsCustomerFilter = !this.showIsCustomerFilter;
    }
    public isCustomerSetSelectedFilter() {
        this.selectedFilter = {
            title: "IsCustomer",
            clear: () => {
                this.clearIsCustomerFilter();
            },
            apply: () => {
                this.showIsCustomerFilter = false;
            }
        }
    }
    public clearIsCustomerFilter(reload = true) {
        this.selectedIsCustomer = []
        this.isCustomerIsApplied = false;
        if(reload)
            this.setItemSource();
    }
    
    public applyIsCustomerFilter(event) { 
        this.selectedIsCustomer = event.items.filter(x => x.isSelected).map(x => x.id)
        this.setItemSource();
        this.showIsCustomerFilter = false;
    }
    @computedFrom("selectedIsCustomer") 
    public get isCustomerFilterActive() {
        return this.selectedIsCustomer && this.selectedIsCustomer.length > 0
    }
    //#endregion

    //#region Severity filter
    public selectedSeverities : any[] = [];
    public showSeverityFilter: boolean;
    public severityIsApplied: boolean;
    toggleSeverityFilter() {
        if(!this.showSeverityFilter) {
            this.closeAllFilters();
        }
        this.showSeverityFilter = !this.showSeverityFilter;
    }
    public severitySetSelectedFilter() {
        this.selectedFilter = {
            title: "Severity",
            clear: () => {
                this.clearSeverityFilter();
            },
            apply: () => {
                this.showSeverityFilter = false;
            }
        }
    }
    public clearSeverityFilter(reload = true) {
        this.selectedSeverities = []
        this.severityIsApplied = false;
        if(reload)
            this.setItemSource();
    }
    
    public applySeverityFilter(event) { 
        this.selectedSeverities = event.items.filter(x => x.isSelected).map(x => x.id)
        this.showSeverityFilter = false;
        this.setItemSource();
    }
    @computedFrom("selectedSeverities") 
    public get severityFilterActive() : boolean {
        return this.selectedSeverities && this.selectedSeverities.length > 0;
    }
    //#endregion

    // #region Active filter
    public selectedActive : any[] = []
    public activeOptions : any[] = [{id: 0, name: "Active"}, {id: 1, name: "Inactive"}]
    public showActiveFilter: boolean;
    public activeIsApplied: boolean;
    toggleActiveFilter() {
        if(!this.showActiveFilter) {
            this.closeAllFilters();
        }
        this.showActiveFilter = !this.showActiveFilter;
    }
    public activeSetSelectedFilter() {
        this.selectedFilter = {
            title: "Active",
            clear: () => {
                this.clearActiveFilter();
            },
            apply: () => {
                this.showActiveFilter = false;
            }
        }
    }
    public clearActiveFilter(reload = true) {
        this.selectedActive = []
        this.activeIsApplied = false;
        if(reload)
            this.setItemSource();
    }
    
    public applyActiveFilter(event) {
        
        this.selectedActive = event.items.filter(x => x.isSelected).map(x => x.id)
        this.setItemSource();
        this.showActiveFilter = false;
    }
    @computedFrom("selectedActive") 
    public get activeFilterActive() {
        return this.selectedActive && this.selectedActive.length > 0
    }
    //#endregion

    //#region column sorting 
    public showColumnSorting: boolean = false;
    public selectedColumnSorting: number[] = [];

    public toggleColumnSortingFilters() {
        if (!this.showColumnSorting) {
            this.closeAllFilters();
        }
        this.showColumnSorting = !this.showColumnSorting;
        this.selectedFilter = {
            title: "Column sorting",
            clear: () => { 
            },
            apply: () => {
                this.applyColumnSortingFilter(this.selectedColumnSorting.map((bId: number) => {
                    return { id: bId };
                }), false);
            }
        }
    }

    public applyColumnSortingFilter(items: any[], reload: boolean = true) {
        this.selectedColumnSorting = items.map(x => x.id);
        if (reload == true) this.setItemSource();
        this.toggleColumnSortingFilters();
    }

    sortByMobile(column: DataGridColumn) {
        this.dataGridVM.sortingTriggered(column);
        this.isColumnFiltering = this.dataGridVM.visibleColumns.some(item => item.isAscending === true || item.isAscending === false);
    }

    sortClass(column: DataGridColumn) {
        if (column.isAscending) {
            return "Ascending"
        }
        else if (column.isAscending == false) {
            return "Descending"
        }
        else {
            return "";
        }
    }

    //#endregion

    toggleMobileFilterDialog() {
        if (!this.isSubFilterOpen) {
            this.isMobileFilterOpen = !this.isMobileFilterOpen;
        }
        this.showONFilter = false;
        this.showCategoryFilter = false;
        this.showIsCustomerFilter = false;
        this.showSeverityFilter = false;
        this.showActiveFilter = false;

    }
    public mobileApplyAllFilters(toggleDialog: boolean = true) {
        if(toggleDialog)
            this.toggleMobileFilterDialog();
        // this.selectedStatusFilter = [];
        this.mobileSelectedfilters.forEach(x => {
            x.apply();
        })
        //Refresh itemSource irrelevant of number of mobileSelectedFilters. Users may unselect all filters (resulting in no selected filters)
        this.setItemSource();
        this.mobileSelectedfilters = []
    }
    hideMobileFilters() {
        this.isMobileFilterOpen = false;    
    }
    public mobileAddSelectedFilter() {
        if (this.selectedFilter) {
            this.mobileSelectedfilters.push(this.selectedFilter)
            this.selectedFilter = null;
        }
    }

    public clearAllFilters() { 
        if(this.dataGridVM) {
            this.dataGridVM.clearSorting();
            this.isColumnFiltering = false;
        }
        this.appliedFilter = null;
        this.filter = null;
        this.clearONFilter(false);
        this.clearCategoryFilter(false); 
        this.clearIsCustomerFilter(false); 
        this.clearSeverityFilter(false); 
        this.clearActiveFilter(false);  

        this.setItemSource();
    }

}